import storeRoot from '../store-root'
import http from '../../services/http'
import queryString from 'querystring'
const moduleName = 'parameterV2'

storeRoot.registerModule(moduleName, {
  namespaced: true,
  state: {

  },
  actions: {
    // 获取水质参数曲线数据
    async getParamerLine ({ commit }, payload) {
      let result = await http.post(
        `/api/Equipment/SensorChartDataDto`, payload
      )
      return result.data
    },
    // 更新水质参数上下限合理范围值
    async updatelimitData ({ commit }, payload) {
      let result = await http.put(`/api/EquipmentSocket/UpdateSensor`, payload)
      return result.data
    },
    // 获取设备耗电量记录
    async getDeviceEnergyHis ({ commit }, payload) {
      let result = await http.get(`/api/Equipment/GetDeviceEnergyHis?${queryString.stringify(payload)}`)
      return result.data
    }
  },
  mutations: {
  }

})

export default moduleName
